import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import moment from 'moment';

import ConfirmDialogProvider from 'context/ConfirmDialogProvider';
import { ModalPopupProvider } from 'context/ModalProvider/ModalProvider';
import { WebSocketProvider } from 'context/WebSocketProvider';
import 'moment/locale/ru';

import Drawer from './components/layout/drawer';
import Header from './components/layout/header';
import Routes from './router';
//import 'devextreme/dist/css/dx.common.css';
//import 'devextreme/dist/css/dx.light.css';
//import './style/dx.material.custom-scheme.css';
//import './style/dx.material.custom-scheme-2.css';
import './style/dx.material.custom-scheme.css';
import './style/main.scss';

moment.locale('ru');

function App() {
  return (
    <>
      <ConfirmDialogProvider>
        <ModalPopupProvider>
          <WebSocketProvider>
            <div className={'container-main rtl toggled'}>
              <Drawer />
              <div style={{ width: '100%' }}>
                <Header />
                <div className="main-blok">
                  <Routes />
                </div>
              </div>
            </div>
          </WebSocketProvider>
        </ModalPopupProvider>
      </ConfirmDialogProvider>
      <ToastContainer />
    </>
  );
}

export default App;
